import { render } from "./ProductHome.vue?vue&type=template&id=a7967bec&scoped=true"
import script from "./ProductHome.vue?vue&type=script&lang=js"
export * from "./ProductHome.vue?vue&type=script&lang=js"

import "./ProductHome.vue?vue&type=style&index=0&id=a7967bec&scoped=true&lang=css"

import exportComponent from "D:\\my\\game-fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7967bec"]])

export default __exports__